import { userStateApi } from '../../../../config/apis';

const initialState = [];

export const states = {
  state: [...initialState],
  reducers: {
    setSuccess(state, payload) {
      return [
        { label: 'AK', key: 'AK' },
        { label: 'AS', key: 'AS' }
      ];
    },
    setFailed() {
      return { ...initialState };
    }
  },
  effects: (dispatch) => ({
    async fetchData(payload, rootState) {
      try {
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: userStateApi,
            data: payload.data
          },
          id: payload.apiId
        });
        this.setSuccess(response);
      } catch (error) {
        this.setFailed();
      }
    }
  })
};
